/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesSk = {
  privacy: {
    pageTitle: "Zásady ochrany súkromia",
    lastUpdated: "Posledná aktualizácia: 1. júna 2026",
    introduction: {
      title: "Úvod",
      body: "WasOK je lokálne orientovaná aplikácia na pomoc pri nakupovaní, navrhnutá tak, aby používateľom pomohla zapamätať si produkty, ktoré predtým kúpili, hodnotili alebo recenzovali.\n\nTieto zásady ochrany súkromia vysvetľujú, aké informácie sa spracúvajú pri používaní aplikácie, ako sa údaje ukladajú a ako môžu fungovať niektoré služby tretích strán.",
    },
    dataStored: {
      title: "Údaje ukladané aplikáciou",
      body: "WasOK ukladá nasledujúce informácie lokálne na vašom zariadení:\n\n• naskenované čiarové kódy produktov\n• názvy produktov a detaily zadané používateľom\n• hodnotenia a komentáre\n• nákupné zoznamy\n• kategórie produktov\n• ceny a informácie o obchodoch\n• fotografie produktov a obchodov\n\nVaše údaje o produktoch a fotografie sa nenahrávajú na servery WasOK.",
    },
    permissions: {
      title: "Používané povolenia",
      camera: {
        title: "Fotoaparát",
        body: "Prístup k fotoaparátu sa používa na:\n\n• skenovanie čiarových kódov\n• fotografovanie produktov",
      },
      photos: {
        title: "Fotografie a médiá",
        body: "Prístup k fotografiám alebo galérii sa používa iba pri:\n\n• pripájaní obrázkov k produktom\n• obnovovaní záloh obsahujúcich fotografie",
      },
      files: {
        title: "Prístup k súborom a úložisku",
        body: "Prístup k súborom sa môže používať na:\n\n• export záložných súborov\n• import záloh vybraných používateľom\n• zdieľanie nákupných zoznamov alebo záloh",
      },
    },
    backup: {
      title: "Funkcie zálohovania a exportu",
      body: "WasOK umožňuje používateľom vytvárať záložné súbory obsahujúce údaje aplikácie a voliteľne fotografie.\n\nZáložné súbory sa vytvárajú lokálne na vašom zariadení a môžu sa ukladať alebo zdieľať pomocou služieb vybraných používateľom, napríklad:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokálne úložisko zariadenia\n\nWasOK nenahráva zálohy na vlastné servery.",
      onlineProductLookup: {
        title: "Online vyhľadávanie produktov",
        body: "Keď v Nastaveniach povolíte online vyhľadávanie čiarových kódov, WasOK môže odoslať iba naskenované číslo čiarového kódu do verejných databáz produktov (napríklad Open Food Facts), aby navrhol názov produktu a značku. WasOK pri tejto funkcii nenahráva vaše hodnotenia, komentáre, fotografie, nákupné zoznamy, kategórie, informácie o obchodoch ani záložné údaje. Túto funkciu môžete kedykoľvek vypnúť v Nastaveniach.",
      },
    },
    advertising: {
      title: "Reklama a služby tretích strán",
      intro:
        "WasOK používa vybrané služby tretích strán na poskytovanie určitých funkcií.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob sa používa na zobrazovanie reklám v aplikácii.\n\nGoogle a jeho partneri môžu spracúvať informácie, ako sú:\n\n• identifikátory reklamy\n• informácie o zariadení\n• IP adresa\n• diagnostické a používateľské informácie\n\nOd používateľov v niektorých regiónoch môže byť pred zobrazením personalizovaných reklám vyžadovaný súhlas.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK používa Firebase Crashlytics na identifikáciu pádov a zlepšenie stability aplikácie.\n\nSprávy o pádoch môžu obsahovať technické informácie, ako sú:\n\n• model zariadenia\n• verzia operačného systému\n• verzia aplikácie\n• diagnostika pádu\n\nSprávy o pádoch zámerne neobsahujú vaše hodnotenia produktov, poznámky, nákupné zoznamy ani fotografie.",
      },
      externalProductDatabases: {
        title: "Externé databázy produktov",
        body: "Funkcia vyhľadávania podľa čiarového kódu môže používať externé databázy produktov na získanie informácií o produkte.\n\nĎalšie informácie nájdete v zásadách ochrany súkromia príslušných poskytovateľov.",
      },
    },
    dataSecurity: {
      title: "Zabezpečenie údajov",
      body: "WasOK ukladá údaje aplikácie lokálne na vašom zariadení pomocou mechanizmov úložiska poskytovaných operačným systémom.\n\nHoci sa prijímajú primerané opatrenia na ochranu lokálnych údajov aplikácie, žiadna metóda elektronického ukladania nie je úplne bezpečná.\n\nPoužívatelia sú zodpovední za udržiavanie záloh dôležitých údajov, ak si to želajú.",
    },
    children: {
      title: "Ochrana súkromia detí",
      body: "WasOK nie je určený deťom mladším ako 13 rokov.",
    },
    notifications: {
      title: "Oznámenia",
      body: "WasOK môže voliteľne vytvárať lokálne oznámenia na vašom zariadení, aby vám pripomenul hodnotenie produktov po nákupe.\n\nTieto oznámenia sa generujú a plánujú lokálne na vašom zariadení a nevyžadujú účet ani vzdialený server.\n\nOznámenia môžete kedykoľvek vypnúť v nastaveniach zariadenia alebo v aplikácii, ak je to podporované.",
    },
    yourControl: {
      title: "Vaša kontrola nad údajmi",
      body: "Môžete:\n\n• kedykoľvek upravovať alebo mazať uložené produkty\n• vymazať údaje aplikácie zo zariadenia\n• odinštalovať aplikáciu\n• exportovať zálohy svojich údajov",
    },
    changes: {
      title: "Zmeny týchto zásad",
      body: "Tieto zásady ochrany súkromia sa môžu časom aktualizovať.\n\nZmeny nadobúdajú účinnosť zverejnením aktualizovanej verzie.",
    },
    contact: {
      title: "Kontakt",
      body: "Ak máte otázky týkajúce sa týchto zásad ochrany súkromia, kontaktujte nás:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Podmienky používania",
    lastUpdated: "Posledná aktualizácia: 1. júna 2026",
    acceptance: {
      title: "Prijatie podmienok",
      body: "Stiahnutím, inštaláciou alebo používaním WasOK súhlasíte s týmito podmienkami používania.\n\nAk s týmito podmienkami nesúhlasíte, aplikáciu by ste nemali používať.",
    },
    license: {
      title: "Licencia",
      body: "WasOK vám udeľuje obmedzenú, nevýhradnú, neprenosnú a odvolateľnú licenciu na používanie aplikácie v súlade s týmito podmienkami.",
    },
    acceptableUse: {
      title: "Prípustné použitie",
      body: "Súhlasíte, že nebudete:\n\n• zneužívať aplikáciu\n• zasahovať do fungovania aplikácie\n• pokúšať sa o spätné inžinierstvo alebo úpravu aplikácie\n• používať aplikáciu v rozpore s platnými zákonmi alebo predpismi",
    },
    localData: {
      title: "Lokálne údaje a zálohy",
      body: "WasOK ukladá používateľské údaje lokálne na zariadení.\n\nPoužívatelia sú zodpovední za udržiavanie záloh dôležitých údajov, ak si to želajú.\n\nHoci môže byť poskytnutá funkcia zálohovania a obnovenia, WasOK nezaručuje ochranu pred stratou, poškodením alebo zlyhaním uložených údajov.",
    },
    advertisements: {
      title: "Reklamy",
      body: "Aplikácia môže zobrazovať reklamy poskytované reklamnými partnermi tretích strán, vrátane Google AdMob.",
    },
    noWarranty: {
      title: "Bez záruky",
      body: "WasOK sa poskytuje „tak, ako je“ a „tak, ako je k dispozícii“ bez akýchkoľvek záruk, výslovných ani implicitných.\n\nNezaručujeme, že:\n\n• aplikácia bude vždy dostupná\n• aplikácia bude bez chýb\n• nikdy nedôjde k strate údajov\n• všetky funkcie budú na všetkých zariadeniach fungovať nepretržite",
    },
    limitationLiability: {
      title: "Obmedzenie zodpovednosti",
      body: "V maximálnom rozsahu povolenom zákonom WasOK a jeho vývojári nenesú zodpovednosť za:\n\n• stratu údajov\n• stratu zisku\n• problémy so zariadením\n• nepriame alebo následné škody\n• prerušenia vyplývajúce z používania alebo neschopnosti používať aplikáciu",
    },
    thirdParty: {
      title: "Služby tretích strán",
      body: "Niektoré funkcie alebo obsah môžu závisieť od služieb tretích strán, vrátane poskytovateľov reklamy a externých služieb úložiska/zdieľania vybraných používateľom.\n\nWasOK nie je zodpovedný za služby tretích strán ani ich pravidlá.",
    },
    productInformation: {
      title: "Informácie o produktoch",
      body: "Niektoré detaily produktov môžu byť získané zo služieb tretích strán na vyhľadávanie podľa čiarového kódu.\n\nWasOK nezaručuje presnosť, úplnosť, dostupnosť ani vhodnosť informácií poskytovaných externými zdrojmi údajov.\n\nPoužívatelia by mali v prípade potreby informácie o produktoch overiť samostatne.",
    },
    changesApp: {
      title: "Zmeny aplikácie",
      body: "WasOK môže byť kedykoľvek upravený, aktualizovaný, pozastavený alebo ukončený bez predchádzajúceho upozornenia.",
    },
    changesTerms: {
      title: "Zmeny týchto podmienok",
      body: "Tieto podmienky môžu byť pravidelne aktualizované.\n\nPokračovaním v používaní aplikácie po nadobudnutí účinnosti aktualizácií vyjadrujete súhlas s revidovanými podmienkami.",
    },
    contact: {
      title: "Kontakt",
      body: "Pri otázkach týkajúcich sa týchto podmienok kontaktujte:\n\nsupport@wasok.app",
    },
  },
};
